"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.withTheme = exports.ThemeProvider = exports.keyframes = exports.createGlobalStyle = exports.css = void 0;
var tslib_1 = require("tslib");
// styled-components.ts
var styledComponents = tslib_1.__importStar(require("styled-components"));
var _a = styledComponents, styled = _a.default, css = _a.css, createGlobalStyle = _a.createGlobalStyle, keyframes = _a.keyframes, ThemeProvider = _a.ThemeProvider, withTheme = _a.withTheme;
exports.css = css;
exports.createGlobalStyle = createGlobalStyle;
exports.keyframes = keyframes;
exports.ThemeProvider = ThemeProvider;
exports.withTheme = withTheme;
exports.default = styled;
